import React from "react";
import { cn } from "@/lib/utils";

interface Tab {
  id: string;
  label: string;
  count?: number;
}

interface NotificationTabsProps {
  tabs: Tab[];
  activeTab: string;
  onChange: (id: string) => void;
}

const NotificationTabs: React.FC<NotificationTabsProps> = ({
  tabs,
  activeTab,
  onChange,
}) => {
  return (
    <div className="scrollbar-none mb-6 w-full overflow-x-auto">
      <div className="inline-flex min-w-max items-center whitespace-nowrap rounded-xl bg-gray-100/60 p-1">
        {tabs.map((tab) => (
          <button
            key={tab.id}
            onClick={() => onChange(tab.id)}
            className={cn(
              "flex shrink-0 items-center gap-2 rounded-lg px-6 py-2 text-xs font-bold transition-all",
              activeTab === tab.id
                ? "bg-white text-black shadow-sm"
                : "text-gray-500 hover:text-gray-900"
            )}
          >
            {tab.label}
            {tab.count !== undefined && tab.count > 0 && (
              <span
                className={cn(
                  "rounded-full px-1.5 py-0.5 text-[10px] font-bold",
                  activeTab === tab.id
                    ? "bg-black text-white"
                    : "bg-gray-200 text-gray-600"
                )}
              >
                {tab.count}
              </span>
            )}
          </button>
        ))}
      </div>
    </div>
  );
};

export default NotificationTabs;
